import React from 'react';
import { ShieldCheck, ArrowRight, Lock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { OrderBump } from './OrderBump';
import { trackAddToCart } from '../MetaPixel';
export function PriceSection() {
  return <section id="precio" className="py-20 px-4 bg-slate-950 relative" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <div className="bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-83">
          {/* Glow Effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-2 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50" data-id="element-84"></div>

          <div className="text-center mb-8" data-id="element-85">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-86">
              ACCESO COMPLETO AL SISTEMA
            </h2>
            <div className="flex justify-center mb-6" data-id="element-87">
              <CountdownTimer data-id="element-88" />
            </div>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-89">
              <span className="text-2xl text-slate-500 line-through decoration-red-500 decoration-2" data-id="element-90">
                $19.99 USD
              </span>
              <span className="text-5xl md:text-6xl font-bold text-white tracking-tight" data-id="element-91">
                $6
                <span className="text-2xl text-slate-400 font-normal" data-id="element-92">.39</span>
              </span>
            </div>
            <p className="text-green-400 font-medium bg-green-500/10 inline-block px-4 py-1 rounded-full text-sm" data-id="element-93">
              🔥 Ahorras 32% · Oferta de Lanzamiento
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-94">
            <div className="flex items-center gap-3 text-slate-300" data-id="element-95">
              <ShieldCheck className="w-5 h-5 text-teal-500" data-id="element-96" />
              <span data-id="element-97">Acceso Instantáneo de por vida</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300" data-id="element-98">
              <ShieldCheck className="w-5 h-5 text-teal-500" data-id="element-99" />
              <span data-id="element-100">Resultados permanentes (Sin terapia)</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300" data-id="element-101">
              <ShieldCheck className="w-5 h-5 text-teal-500" data-id="element-102" />
              <span data-id="element-103">Garantía de devolución de 30 días</span>
            </div>
          </div>

          <OrderBump data-id="element-104" />

          <div className="flex justify-center mt-8" data-id="element-105">
            <a href="https://factorexpansion.com/cart/47377487495398:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full max-w-sm bg-yellow-500 hover:bg-yellow-400 text-slate-950 font-bold text-xl py-5 px-8 rounded-2xl shadow-[0_0_30px_rgba(234,179,8,0.3)] transition-all transform hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(234,179,8,0.5)] flex items-center justify-center gap-2 group" data-id="element-106">
              DESCARGAR AHORA POR $6.39
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-107" />
            </a>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-108">
            <Lock className="w-3 h-3" data-id="element-109" />
            <span data-id="element-110">Pago Único y Seguro</span>
          </div>
        </div>
      </div>
    </section>;
}